import { AnyAction } from 'redux';
import {
  GlobalActions,
  TARIF_CHECKED,
  VereinbarungenChanged,
  VertragslaufzeitChanged,
  VorversicherungChanged,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  PhVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { PhActions } from '../phActions';
import { IAppState } from '../appState';

export const phVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.PH, state);
  switch (action.type) {
    case PhActions.SELBSTBETEILIGUNG_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = action.payload;
      return { ...sectionState, selbstbeteiligung };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: PhVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.PH) {
        return {
          ...getVetragsOptionenFromVorvertrag(sectionState, actionPayload),
        };
      }
      return sectionState;
    }
    case GlobalActions.VERTRAGSLAUFZEIT_CHANGED: {
      const changedLaufzeitEvent: VertragslaufzeitChanged = action.payload;
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      if (action.payload.appId === App.PH) {
        newState.ausgewaehltevertragslaufzeit = changedLaufzeitEvent.vertragslaufzeit;
        newState.vertragslaufzeit = changedLaufzeitEvent.vertragslaufzeit;
      }
      return newState;
    }
    case GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED: {
      const actionPayload: VorversicherungChanged = action.payload;
      if (actionPayload.appId === App.PH) {
        const newState: Vertragsoptionen = cloneDeep(sectionState);
        newState.vorversicherungVorhanden = actionPayload.vorhanden;
        return newState;
      }
      return sectionState;
    }
    case TARIF_CHECKED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case PhActions.VERSICHERUNGSSUMME_CHANGED: {
      const selectedVersSumme: number = action.payload.versSummeLeistung;
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      newState.versicherungssumme = selectedVersSumme;
      return newState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.PH);
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      const kuendigungenPayload = actionPayload.kuendingungChanged.some(elem => {
        return elem.appId === App.PH;
      });
      if (kuendigungenPayload) {
        newState.vorvertragGekuendigt = true;
      }
      return newState;
    }
    case PhActions.PRODUKT_DATEN_VORBELEGT: {
      const relevantVorbelegungdaten: PhVorbelegungdaten = action.payload;
      return { ...sectionState, urbeginn: relevantVorbelegungdaten.urbeginn };
    }
    default:
      return sectionState;
  }
};
